import { createDomain, sample } from 'effector'
import { employeeModel } from '~/entities/common/Taxipark/Employee'
import { AxiosErrorType, Employee } from '~/shared/api'
import { backFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.taxipark.employees.add')

export const createFx = domain.createEffect<
  employeeModel.FormValues,
  Employee,
  AxiosErrorType
>({
  async handler(values) {
    const { regionsIds, rolesIds, carRentalsIds, timezone, locale, ...attrs } =
      values
    const employee = new Employee({
      ...attrs,
      ...(isString(timezone) && { timezone }),
      ...(isString(locale) && { locale }),
    })

    if (Array.isArray(regionsIds)) employee.setRegions(regionsIds)
    if (Array.isArray(rolesIds)) employee.setRoles(rolesIds)
    if (Array.isArray(carRentalsIds)) employee.setCarRentals(carRentalsIds)

    const result = await employee.save()
    return result.getModel() as Employee
  },
})

export const formSubmitted = domain.createEvent<employeeModel.FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.user created' as const,
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, backFx],
})
sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
